export default {
  data() {
    return {
      options: {
        legend: {
          onClick: (e, legendItem) => {
            const ci = this.$refs.chart.$data._chart;
            const index = legendItem.datasetIndex;

            if (ci.isDatasetVisible(index)) {
              ci.data.datasets[index].hidden = true;
              ci.update();
            } else {
              ci.data.datasets[index].hidden = false;
              ci.update();
            }

            let maxValue = 1;
            for (let dataset of ci.data.datasets) {
              if (dataset.hidden) {
                continue;
              }

              for (let data of dataset.data) {
                if (data > maxValue) {
                  maxValue = data;
                }
              }
            }

            this.internalMaxY = maxValue;
            this.$emit("max-y-updated", maxValue);
          }
        }
      }
    };
  }
};
